<!--
 * @Author: zhb 1822394027@qq.com
 * @Date: 2022-10-05 11:54:29
 * @LastEditors: zhb 1822394027@qq.com
 * @LastEditTime: 2022-10-17 18:14:55
 * @FilePath: \huayue\src\pages\home\home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-wrap">
    <AppBar />
    <div class="page-content">
      <div class="home-canvas">
        <swiper ref="swiper" class="swiper" :options="swiperOption">
          <!-- <swiper-slide>
              <div class="home-view" style="cursor: initial;">
              <div class="home-view-background">
                
                 <img src="@/assets/home/20241108184510.jpg" alt="" class="video" />
              </div>
               <div class="por-container">
 <video width="100%" height="520" controls class="viedo">
                  <source
                    src="/37fc06a5c605d586dcd2ec07bd508c6d.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>

               </div>
              </div>
          </swiper-slide> -->
          <swiper-slide>
            <div class="home-view" style="cursor: initial;">
              <div class="home-view-background">
                <!-- <video
                  src="@/assets/home/home-canvas.png"
                  autoplay
                  loop
                  muted
                ></video> -->
                <img src="@/assets/home/home-canvas.png" alt="" class="video" />
              </div>
              <!-- <home-view-canvas class="home-view-canvas" /> -->
              <div class="por-container">
                <div class="home-view-info">
                  <div class="home-view-info-top">
                    DHCP
                  </div>
                  <div class="home-view-info-title">
                    数字化人才云平台
                  </div>
                  <div class="home-view-info-content">
                    科技让人力资源更智能,帮助企业实现人才管理各部分的数字化。
                    人才多维数据的打通，立体、直观、联动的对人才数据进行呈现。
                  </div>
                  <div class="home-view-btn" @click="openBealter">
                    立即体验
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-for="(item, index) in carouselList" :key="index">
            <div class="home-view" @click="goto(item)">
              <img :src="item.img" alt="" class="home-view2" />
            </div>
          </swiper-slide>
          <div slot="pagination" class="bannerbox-page swiper-pagination"></div>
        </swiper>
      </div>
      <div class="home-view-nav">
        <div
          class="home-view-nav-item"
          @click="$router.push({ path: '/cloudplatform' })"
        >
          <div class="home-view-nav-item-left">
            <img
              :src="require('@/assets/home/analysis-platform-icon1.png')"
              alt=""
              srcset=""
            />
          </div>
          <div class="home-view-nav-item-right">
            <div>DHCP数字化人才云平台</div>
            <div>助力企业人才优化管理</div>
          </div>
        </div>
        <div
          class="home-view-nav-item"
          @click="$router.push({ path: '/analysis' })"
        >
          <div class="home-view-nav-item-left">
            <img
              :src="require('@/assets/home/analysis-platform-icon2.png')"
              alt=""
              srcset=""
            />
          </div>
          <div class="home-view-nav-item-right">
            <div>BI分析平台</div>
            <div>助力企业精准人才决策</div>
          </div>
        </div>
        <div
          class="home-view-nav-item"
          @click="$router.push({ path: '/mobileterminal' })"
        >
          <div class="home-view-nav-item-left">
            <img
              :src="require('@/assets/home/analysis-platform-icon3.png')"
              alt=""
              srcset=""
            />
          </div>
          <div class="home-view-nav-item-right">
            <div>员工移动云平台</div>
            <div>提升企业管理效率，提升员工满意度</div>
          </div>
        </div>
        <div
          class="home-view-nav-item"
          @click="$router.push({ path: '/passPlatform' })"
        >
          <div class="home-view-nav-item-left">
            <img
              :src="require('@/assets/home/analysis-platform-icon4.png')"
              alt=""
              srcset=""
            />
          </div>
          <div class="home-view-nav-item-right">
            <div>前端PASS智能平台</div>
            <div>可视化智能设置平台，帮助管理落地</div>
          </div>
        </div>
      </div>
      <div class="digitization-cloud-platform">
        <div class="title">数字化人才云平台</div>
        <el-tabs
          v-if="digitizationList.length != 0"
          v-model="activeDigitizationNav"
        >
          <!-- <transition name="demand-fade" mode="out-in"> -->
          <el-tab-pane
            v-for="dagitization in digitizationList"
            :key="dagitization.key"
            :name="dagitization.key"
          >
            <div slot="label" class="tag-optios-label">
              <div class="tag-optios">
                <div>
                  <img :src="dagitization.labelImage" alt="" srcset="" />
                </div>
                <div>{{ dagitization.labelName }}</div>
              </div>
            </div>
            <div :key="activeDigitizationNav" class="digitization-content">
              <div class="digitization-content-left">
                <div class="digitization-content-left-title">
                  {{ dagitization.title }}
                </div>
                <div
                  v-for="(item, index) in dagitization.info"
                  :key="index"
                  class="digitization-content-left-content"
                >
                  <img
                    :src="require('@/assets/home/content-tip.png')"
                    alt=""
                    srcset=""
                  />
                  <div class="digitization-text">{{ item }}</div>
                </div>
              </div>
              <div
                class="digitization-content-right"
                v-html="dagitization.rightImage"
              >
                <!-- <img :src="dagitization.rightImage" alt="" srcset="" /> -->
              </div>
            </div>
            <!-- <transition name="el-fade-in-linear">
            </transition> -->
          </el-tab-pane>
          <!-- </transition> -->
        </el-tabs>
      </div>
      <div class="demand-customization">
        <div class="customization-wrap">
          <div class="demand-customization-title">
            以数字化人才管理助力企业数字化转型
          </div>
          <div class="demand-customization-tag">
            <div
              v-for="(item, index) in demandCustomizatioTagList"
              :key="index"
              class="demand-customization-tag"
            >
              <div
                class="demand-customization-tag-item"
                :class="{
                  'demand-customization-tag-item-active':
                    item.index === demandCustomizatioTagActiveIndex
                }"
                @click="changeDemand(index)"
              >
                <div>
                  <img :src="item.url" alt="" srcset="" />
                </div>
                <div>{{ item.title }}</div>
              </div>
              <div v-show="index < 3" class="demand-customization-tag-arrow">
                <img
                  :src="require('@/assets/home/demand-customization7.png')"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          </div>
          <transition name="demand-fade" mode="out-in">
            <div
              v-if="demandCustomizatioContentList.length != 0"
              :key="demandCustomizatioTagActiveIndex"
              class="demand-customization-content"
            >
              <div
                class="demand-customization-content-left"
                v-html="
                  demandCustomizatioContentList[
                    demandCustomizatioTagActiveIndex
                  ].gif
                "
              >
                <!-- <img :src="demandCustomizatioContentList[demandCustomizatioTagActiveIndex].gif" alt="" srcset="" /> -->
              </div>
              <div class="demand-customization-content-right">
                <div class="demand-customization-content-right-title">
                  {{
                    demandCustomizatioTagList[demandCustomizatioTagActiveIndex]
                      .title
                  }}
                </div>
                <div
                  v-for="(item, index) in demandCustomizatioContentList[
                    demandCustomizatioTagActiveIndex
                  ].contentList"
                  :key="index"
                  class="demand-customization-panel"
                >
                  <img
                    :src="require('@/assets/home/content-tip.png')"
                    alt=""
                    srcset=""
                  />
                  <div>{{ item }}</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="appointment-demonstration">
        <h4 class="title">了解更多有关华跃产品与服务信息</h4>
        <h5 class="subtitle">您还可以预约我们的产品演示</h5>
        <div class="appointment-demonstration-btn" @click="openBealter">
          <img
            :src="require('@/assets/home/appointment-demonstration1.png')"
            alt=""
          />
          <span>预约产品演示</span>
        </div>
      </div>
      <div class="qyvideo">
        <div class="title">
          华跃HR<br />
          优质产品、优质服务<br />
          由客户来定义
        </div>
        <swiper ref="swiper" class="swiper" :options="swiperOption2">
          <swiper-slide>
            <div class="classic-case-centent">
              <div class="classic-case-List">
                <div
                  v-for="(caseItem, caseIndex) in qyvideoList"
                  :key="caseIndex"
                  class="classic-case-item"
                >
                  <div class="companyImg">
                    <!-- <vue-core-video-player :src="caseItem.url"  
                :autoplay="false"
                :title="caseItem.title"
                preload="nona"
                :loop="true"
                controls="auto"
                /> -->
                    <video
                      width="100%"
                      height="130"
                      class="viedo"
                      loading="lazy"
                      controls="auto"
                    >
                      <source :src="caseItem.url" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div class="case-item-content">
                    <div class="case-item-text-warp">
                      <div class="case-item-title">{{ caseItem.title }}</div>
                      <div class="case-item-describe">
                        {{ caseItem.content }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="classic-case-centent">
              <div class="classic-case-List">
                <div
                  v-for="(caseItem, caseIndex) in qyvideoList2"
                  :key="caseIndex"
                  class="classic-case-item"
                >
                  <div class="companyImg">
                    <!-- <vue-core-video-player :src="caseItem.url"  
                :autoplay="false"
                :title="caseItem.title"
                preload="nona"
                :loop="true"
                controls="auto"
                /> -->
                    <video
                      width="100%"
                      height="130"
                      class="viedo"
                      loading="lazy"
                      controls="auto"
                    >
                      <source :src="caseItem.url" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div class="case-item-content">
                    <div class="case-item-text-warp">
                      <div class="case-item-title">{{ caseItem.title }}</div>
                      <div class="case-item-describe">
                        {{ caseItem.content }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div
            slot="pagination"
            class="bannerbox-page swiper-pagination2"
          ></div>
        </swiper>
      </div>
      <div class="enterptise-choose">
        <div class="title">中大型企业信赖的选择</div>
        <el-tabs v-model="activeDemoIndex" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in enterptiseDemoTagList"
            :key="index"
            :label="item.label"
            :name="item.name"
          />
        </el-tabs>
        <div class="classic-case-centent">
          <div class="classic-case-List">
            <div
              v-for="(caseItem, caseIndex) in enterptiseDemoDetailList"
              :key="caseIndex"
              class="classic-case-item"
              @click="lookToCase(caseItem)"
            >
              <div class="companyImg">
                <img :src="caseItem.icon" alt="" class="item-img" />
              </div>
              <div class="case-item-content">
                <img :src="caseItem.logo" alt="" class="case-item-logo" />
                <div class="case-item-text-warp">
                  <div class="case-item-title">{{ caseItem.title }}</div>
                  <div class="case-item-type">{{ caseItem.summaryTitle }}</div>
                  <div class="case-item-describe">
                    {{ caseItem.description }}
                  </div>
                </div>
                <img
                  :src="require('@/assets/customer/icon/quotes-left.png')"
                  alt=""
                  class="quotes-left"
                />
                <img
                  :src="require('@/assets/customer/icon/quotes-right.png')"
                  alt=""
                  class="quotes-right"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="enterprise-more-btn" @click="moreEnterprise">
          查看更多案例
        </div>
        <div class="enterprise-partner" ref="enterprisePartner">
          <img
            :src="require('@/assets/home/partner-title.png')"
            alt=""
            srcset=""
          />
          <div
            ref="enterprisePartnerItemWrap"
            class="enterprise-partner-item-wrap"
          >
            <div
              v-for="(item, index) in partnerList"
              :key="index"
              class="enterprise-partner-item"
              :style="{ animationDuration: `${partnerList.length * 2}s` }"
            >
              <img :src="item" alt="" srcset="" />
            </div>
            <div v-if="partnerRecursion" style="display:flex">
              <div
                v-for="(item, index) in partnerList"
                :key="index"
                class="enterprise-partner-item"
                :style="{ animationDuration: `${partnerList.length * 2}s` }"
              >
                <img :src="item" alt="" srcset="" />
              </div>
            </div>
          </div>
          <!-- <div ref="enterprisePartnerItemWrap" class="enterprise-partner-item-wrap">
            <div v-for="(item, index) in partnerList" :key="index" class="enterprise-partner-item">
              <img :src="require(`@/assets/home/${item}.png`)" alt="" srcset="" />
            </div> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="enterprise-advertisement">
        <!-- <enterprise-advertisement /> -->

        <img
          :src="require('@/assets/home/enterprise-advertisement1.png')"
          alt=""
          srcset=""
          class="enterprise-advertisement1"
        />
        <div class="enterprise-advertisement-num">
          <div class="enterprise-advertisement-num-item">
            <div class="enterprise-advertisement-num-item-top">
              <div>10万+</div>
              <div>服务企业HR人数</div>
            </div>
            <div class="enterprise-advertisement-num-item-foot">
              <div>100万+</div>
              <div>HR线上线下培训赋能</div>
            </div>
          </div>
          <img
            :src="require('@/assets/home/enterprise-advertisement2.png')"
            alt=""
            srcset=""
          />
          <div class="enterprise-advertisement-num-item">
            <div class="enterprise-advertisement-num-item">
              <div class="enterprise-advertisement-num-item-top">
                <div>20亿+</div>
                <div>日处理数据条数</div>
              </div>
              <div class="enterprise-advertisement-num-item-foot">
                <div>30万+</div>
                <div>每年产生HR招聘行为数据</div>
              </div>
            </div>
          </div>
          <img
            :src="require('@/assets/home/enterprise-advertisement2.png')"
            alt=""
            srcset=""
          />
          <div class="enterprise-advertisement-num-item">
            <div class="enterprise-advertisement-num-item">
              <div class="enterprise-advertisement-num-item-top">
                <div>2000万+</div>
                <div>服务企业员工人数</div>
              </div>
              <div class="enterprise-advertisement-num-item-foot">
                <div>30万+</div>
                <div>协助企业人才盘点人数</div>
              </div>
            </div>
          </div>
        </div>
        <div class="get-product-advertisement-btn" @click="openBealter">
          获取产品演示
        </div>
        <div class="get-product-advertisement-phone">
          <img
            :src="require('@/assets/home/enterprise-advertisement3.png')"
            alt=""
            srcset=""
          />
          <span v-html="preSales"></span>、<span v-html="afterSales"></span>
        </div>
      </div>
      <el-backtop target="body" />
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import HomeViewCanvas from '@/components/home-view-canvas.vue'
import { getColumnChild } from '@/api/column'
import { getContentList, getContentDetail } from '@/api/content'
import { getVariableInfo } from '@/api/variable'
// import EnterpriseAdvertisement from '@/components/enterprise-advertisement.vue';
export default {
  name: 'HomeView',
  components: {
    HomeViewCanvas,
    Swiper,
    SwiperSlide
    // EnterpriseAdvertisement,
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        effect: 'fade',
        // loop: true,
        // 因为加了视频，所以要暂停自动轮播
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2: {
        spaceBetween: 30,
        effect: 'fade',
        // loop: true,
        // 因为加了视频，所以要暂停自动轮播
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: '.swiper-pagination2',
          clickable: true
        }
      },
      carouselList: [
        // {
        //   website: 'http://www.baidu.com',
        //   img: require('@/assets/home/home-canvas2.png'),
        // },
      ],
      activeDigitizationNav: '',
      digitizationList: [
        // {
        //   key: 'first',
        //   labelImage: require('@/assets/home/tag-optios-icon1.png'),
        //   labelName: '战略组织',
        //   title: '满足企业战略规划需要，集团化组织布局',
        //   rightImage: require('@/assets/home/digitization-content1.png'),
        //   info: [
        //     '解决企业由于经营发展带来的对战略组织定时进行大量调整的需求',
        //     '解决企业应为成本预算的要求进行组织的模拟推演，预判未来企业组织架构的走向和人员编制的变化，并根据推演结果进行薪酬预算管理。',
        //     '解决企业由于发展需要建立的临时性组织或分支机构的前身（项目组），并结合流程管理和任务管理对项目的关键任务节点和整个项目进程进行监督。',
        //   ],
        // },
        // {
        //   key: 'second',
        //   labelImage: require('@/assets/home/tag-optios-icon2.png'),
        //   labelName: '人才招聘',
        //   title: '人才招聘',
        //   rightImage: require('@/assets/home/digitization-content2.png'),
        //   info: [
        //     '实现企业一键发布岗位招聘信息，一键下载简历信息。',
        //     '以一系列合理化的招聘流程，实时管控整个招聘过程，减少企业在招聘中人力物力的投入。',
        //     '在线上轻松完成简历初筛、面试安排、信息通知等等工作，大幅提升HR工作效率及招聘成功率。  ',
        //   ],
        // },
        // {
        //   key: 'third',
        //   labelImage: require('@/assets/home/tag-optios-icon3.png'),
        //   labelName: '人才培育',
        //   title: '人才培育',
        //   rightImage: require('@/assets/home/digitization-content3.png'),
        //   info: [
        //     '以资源整合为基础，构建线上培训、考试一体化中心。',
        //     '为企业打造全方位、多层次、高质量的人才培育平台。',
        //     '使得培训不再是形式上的培训，将会是有培训、有跟踪、有考核、有晋升的流程化管理。  ',
        //   ],
        // },
        // {
        //   key: 'four',
        //   labelImage: require('@/assets/home/tag-optios-icon4.png'),
        //   labelName: '绩效激励',
        //   title: '绩效激励',
        //   rightImage: require('@/assets/home/digitization-content4.png'),
        //   info: [
        //     '帮助企业实现将企业战略目标转化为内部活动的过程管理。',
        //     '实现从结果考核到过程考核的转化。',
        //     '支持KPI、360、OKR等多种绩效方式的落地执行。',
        //   ],
        // },
        // {
        //   key: 'five',
        //   labelImage: require('@/assets/home/tag-optios-icon5.png'),
        //   labelName: 'BI分析',
        //   title: 'BI分析',
        //   rightImage: require('@/assets/home/digitization-content5.png'),
        //   info: [
        //     '快速准确地提供报表，并给出决策数据依据。',
        //     '快速实现数据统计分析，并根据要求进行同比、环比、趋势等等分析功能。',
        //     '在实现可视化数据的同时，能够深入挖掘数据信息，实现数据穿透',
        //   ],
        // },
      ],
      activeDemoIndex: '1605405080163672064',
      activeIndex: 0,
      demandCustomizatioTagActiveIndex: 0,
      demandCustomizatioTagList: [
        // {
        //   title: '需求定制',
        //   url: require('@/assets/home/demand-customization3.png'),
        //   index: 0,
        // },
        // {
        //   title: '项目管理',
        //   url: require('@/assets/home/demand-customization4.png'),
        //   index: 1,
        // },
        // {
        //   title: '数据安全',
        //   url: require('@/assets/home/demand-customization5.png'),
        //   index: 2,
        // },
        // {
        //   title: '售后服务',
        //   url: require('@/assets/home/demand-customization6.png'),
        //   index: 3,
        // },
      ],
      demandCustomizatioContentList: [],
      enterptiseDemoTagList: [
        {
          name: '1605405080163672064',
          label: '全部行业'
        }
      ],
      enterptiseDemoDetailList: [],
      productCenterList: [
        '华跃eHR',
        '人事管理系统',
        '考勤管理系统',
        '餐饮管理系统',
        '薪资管理系统',
        '招聘管理',
        '培训管理',
        '绩效管理',
        '硬件系统',
        '门禁管理系统',
        '报表功能'
      ],
      serviceAndPromiseList: [
        '5S服务',
        '1000＋实施案例',
        'HR管理讲座',
        'HR经理人沙龙',
        '7x24小时服务',
        '技术服务，历史档案'
      ],
      aboutUsList: [
        '关于华跃',
        '公司环境',
        '华跃资质',
        '华跃荣誉',
        '员工风采',
        '员工风采',
        '华跃新闻',
        '行业新闻',
        '华跃百科'
      ],
      partnerList: [
        'partner1',
        'partner2',
        'partner3',
        'partner4',
        'partner5',
        'partner6',
        'partner7'
      ],
      enterprisePartnerScrollTimer: null,
      preSales: '',
      afterSales: '',
      qyvideoList: [
        {
          url: '/鸿图.mp4',
          title: '广东鸿图科技股份有限公司',
          content: `
华跃HR系统功能强大，操作简单易上手，团队的服务技术都很好，华跃HR系统很好用，点赞`
        },
        {
          url: '/彩迅.mp4',
          title: '彩迅工业（中山）有限公司',
          content: `
华跃系统大大的提高了人事的工作效率，给华跃HR系统点赞！`
        },
        {
          url: '/合和.mp4',
          title: '广东合和建筑五金制品有限公司',
          content: `
华跃售后团体一直以来认真负责，及时响应地解决问题，值得点赞！`
        },
        {
          url: '/振鸿.mp4',
          title: '佛山市三水振鸿钢制品有限公司',
          content: `
华跃售后5星好评，10分满意！`
        },
        {
          url: '/美涂士.mp4',
          title: '广东美涂士建材股份有限公司',
          content: `
在实施过程中，各位顾问都积极热情的服务，受到了大家一致的好评，为他们的专业热心点赞！`
        },
        {
          url: '/日东.mp4',
          title: '广东日东工具有限公司',
          content: `
华跃的实施团队服务技术都很好，华跃HR系统解决了我们日常工作的难题，系统很好用，点赞！`
        },
        {
          url: '/伟邦.mp4',
          title: '广东伟邦科技股份有限公司',
          content: `
我们今年又升级了一个新版本，感谢华跃客服部欧经理为我们完美解决问题，系统现在也用得比较顺，感谢！`
        },
        {
          url: '/佳成.mp4',
          title: '广东佳成新能源有限公司',
          content: `
华跃全面一体化的HR系统，极大的提高了公司人事管理方面的工作效率及系统化管理，华跃的实施手法服务质量也是棒棒的！`
        },
        {
          url: '/三晶.mp4',
          title: '广州三晶电气有限公司',
          content: `
感谢华跃售后部门，为我司人力资源系统的使用提供了优质的服务和专业的技术支持！`
        },
        {
          url: '/三五.mp4',
          title: '广州三五汽车部件有限公司',
          content: `
华跃售后5星好评，10分满意！`
        },
        {
          url: '/熵能.mp4',
          title: '广州熵能创新材料股份有限公司',
          content: `
华跃售后部门在系统后期运维过程中专业高效，表现优异，五星好评！`
        },
        {
          url: '/松柏.mp4',
          title: '松柏（广东）电池工业有限公司',
          content: `
华跃售后服务周到，反应迅速，专业高效，问题解决满意100分！`
        },
        {
          url: '/三锐.mp4',
          title: '珠海三锐精工科技有限公司',
          content: `
华跃售后五星好评，售后吴斯薇小姐姐友善有效，为她点赞！`
        },
        {
          url: '/联升.mp4',
          title: '广东联升精密智能装备科技有限公司',
          content: `
华跃HR系统功能强，服务好，用户操作简单，提升了工作效率，给华跃点赞！`
        },
        {
          url: '/祥鑫.mp4',
          title: '佛山市祥鑫汽车电子科技有限公司',
          content: `
华跃售后部门在后期维护过程中表现优异，高效专业，值得点赞！`
        }
      ],
      qyvideoList2: [
        {
          url: '/双优月/惠利普.mp4',
          title: '广东惠利普智能科技股份有限公司',
          content: `华跃系统操作简单，系统功能强，服务好，效率直接拉满，给华跃点赞！`
        },
        {
          url: '/双优月/景隆.mp4',
          title: '南海长海发电有限公司',
          content: `华跃的售后服务太棒了，回复的很及时，解答的很耐心，让人感到非常的贴心，这样的服务值得信赖！`
        },
        {
          url: '/双优月/康宝.mp4',
          title: '广东康宝电器股份有限公司',
          content: `华跃HR的软件系统使用方便，实施服务技术精湛，点个赞！`
        },
        {
          url: '/双优月/康政.mp4',
          title: '中山市康政医疗器材有限公司',
          content: `华跃HR系统功能好，服务好，有效地提高了工作效率，给华跃点赞！`
        },
        {
          url: '/双优月/美博.mp4',
          title: '广东美博制冷设备有限公司',
          content: `华跃HR系统售后超给力，问题响应快，解决专业又耐心，用着特安心！`
        },
        {
          url: '/双优月/顺纺.mp4',
          title: '佛山市顺德区顺纺（集团）有限公司',
          content: `华跃售后技术专业，服务到位，处理及时，为你点赞！`
        },
        {
          url: '/双优月/嘉德.mp4',
          title: '珠海市嘉德电能科技有限公司',
          content: `自嘉德HR系统项目启动以来，华跃的工程师黄振邦，始终以高度的责任心，扎实的技术能力和出色的服务态度，全力投入系统搭建工作，我们为黄工的专业精神点赞！`
        },
        {
          url: '/双优月/威力.mp4',
          title: '广东威力电器有限公司',
          content: `华跃系统非常的专业，功能非常强大，在跟我们的合作过程中，能够帮我们很好的解决我们日常的一些难题，为华跃点赞！`
        },
        {
          url: '/双优月/微观.mp4',
          title: '	广东微观控股有限公司',
          content: `华跃售后优质服务，优质供应商，为工程师点赞！`
        },
        {
          url: '/双优月/旭源.mp4',
          title: '	旭源电子（珠海）有限公司',
          content: `非常感谢贵司一直以来的技术支持与服务保障，系统运行很稳定，对客户的需求也能快速响应，保障了我们工作的正常运行并且顺利完成相关工作，感谢贵司团队的辛苦付出，谢谢！`
        }
      ]
    }
  },
  mounted() {
    this.getCarousel()
    this.getPageColumn()
    this.getPartner()
    this.getCaseLabalList()
    this.getVariable()
    // this.playVideo();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.enterprisePartnerScroll())
  },
  methods: {
    // 顶部图
    getCarousel() {
      var params = { columnId: '1608366121839452160', pageNum: 1, pageSize: 99 }
      getContentList(params).then(res => {
        const { result } = res
        for (var i = 0; i < result.data.length; i++) {
          var carousel = {
            website: result.data[i].description,
            img: result.data[i].icon
          }
          this.carouselList.push(carousel)
        }
      })
    },

    // 获取页面栏目
    getPageColumn() {
      const params = { parentId: '1605128373091393536' }
      getColumnChild(params).then(async res => {
        const { result } = res
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '数字化人才云平台') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99 }
            getContentList(data).then(async rrs => {
              const rrsult = rrs.result
              this.activeDigitizationNav = rrsult.data[0].id
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id)
                const rtsult = rts.result
                var doc = new DOMParser().parseFromString(
                  rtsult.defaultContent,
                  'text/html'
                )
                var digitization = {
                  key: rtsult.id,
                  labelImage: rtsult.icon,
                  labelName: rtsult.title,
                  title: rtsult.summaryTitle,
                  rightImage: doc.documentElement.textContent.replace(
                    /&nbsp;/g,
                    ' '
                  ),
                  info: []
                }
                for (var x = 0; x < rtsult.elements.length; x++) {
                  digitization.info.push(rtsult.elements[x].content)
                }
                this.digitizationList.push(digitization)
              }
            })
          } else if (result[i].name === '以数字化人才管理助力企业数字化转型') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99 }
            getContentList(data).then(async rrs => {
              const rrsult = rrs.result
              for (var j = 0; j < rrsult.data.length; j++) {
                this.demandCustomizatioTagList.push({
                  title: rrsult.data[j].title,
                  url: rrsult.data[j].icon,
                  index: j
                })
                const rts = await getContentDetail(rrsult.data[j].id)
                const rtsult = rts.result
                const doc = new DOMParser().parseFromString(
                  rtsult.defaultContent,
                  'text/html'
                )
                var demandCustomizatioContent = {
                  gif: doc.documentElement.textContent.replace(/&nbsp;/g, ' '),
                  contentList: []
                }
                for (var x = 0; x < rtsult.elements.length; x++) {
                  demandCustomizatioContent.contentList.push(
                    rtsult.elements[x].content
                  )
                }
                this.demandCustomizatioContentList.push(
                  demandCustomizatioContent
                )
              }
            })
          }
        }
      })
    },

    // 合作伙伴列表
    getPartner() {
      var params = {
        columnId: '1605405080163672064',
        pageNum: 1,
        pageSize: 99,
        commendation: 16,
        cascade: true
      }
      getContentList(params).then(res => {
        this.partnerList = []
        const { result } = res
        for (var i = 0; i < result.data.length; i++) {
          this.partnerList.push(result.data[i].logo)
        }
        this.$nextTick(() => {
          this.enterprisePartnerScroll()
          window.addEventListener('resize', this.enterprisePartnerScroll())
        })
      })
    },

    getVariable() {
      getVariableInfo({ label: 'Hotline' }).then(res => {
        const { result } = res
        var doc = new DOMParser().parseFromString(result.content, 'text/html')
        this.preSales = doc.documentElement.textContent.replace(/&nbsp;/g, ' ')
      })
      getVariableInfo({ label: 'afterSales' }).then(res => {
        const { result } = res
        var doc = new DOMParser().parseFromString(result.content, 'text/html')
        this.afterSales = doc.documentElement.textContent.replace(
          /&nbsp;/g,
          ' '
        )
      })
    },

    goto(item) {
      if (item.website != '') {
        window.open(item.website, '_blank')
      }
    },

    getCaseList() {
      if (this.activeIndex === 0) {
        var params = {
          columnId: this.enterptiseDemoTagList[this.activeIndex].name,
          pageNum: 1,
          pageSize: 6,
          commendation: 6,
          cascade: true
        }
        getContentList(params).then(res => {
          const { result } = res
          this.enterptiseDemoDetailList = result.data
        })
      } else {
        var data = {
          columnId: this.enterptiseDemoTagList[this.activeIndex].name,
          pageNum: 1,
          pageSize: 6,
          commendation: 6
        }
        getContentList(data).then(res => {
          const { result } = res
          this.enterptiseDemoDetailList = result.data
        })
      }
    },

    handleClick(e) {
      this.activeIndex = Number(e.index)
      this.enterptiseDemoDetailList = []
      this.getCaseList()
    },

    getCaseLabalList() {
      getColumnChild({ parentId: '1605405080163672064' }).then(res => {
        const { result } = res
        for (var i = 0; i < result.length; i++) {
          this.enterptiseDemoTagList.push({
            name: result[i].id,
            label: result[i].name
          })
        }
        this.getCaseList()
      })
    },

    lookToCase(caseItem) {
      this.$router.push({ path: `/caseindex/${caseItem.id}` })
    },

    partnerRecursion() {
      return true
    },

    enterprisePartnerScroll() {
      const el = this.$refs.enterprisePartnerItemWrap
      if (el.scrollWidth - el.offsetWidth > 10) {
        clearInterval(this.enterprisePartnerScrollTimer)
        const lenPx = this.partnerList.length * 135
        el.style = `--parnertwrapscrollWidth: ${lenPx}px;--parnertwrapscrollhiddenWidth: ${lenPx}px`
        // el.style = `--parnertwrapscrollWidth: ${el.clientWidth}px;--parnertwrapscrollhiddenWidth: ${lenPx}px`;
      }
      this.$refs.enterprisePartner.style = 'display: none'
      setTimeout(() => {
        this.$refs.enterprisePartner.style = 'display: block'
      }, 50)
    },

    changeDemand(index) {
      this.demandCustomizatioTagActiveIndex = index
    },

    moreEnterprise() {
      this.$router.push({ name: 'CustomerCase' })
    },

    openBealter() {
      this.$refs.altProduct.tobealter()
    },
    openBealter2() {
      this.$refs.ast.drawer = true
    }
  }
}
</script>
<style lang="less">
:root {
  --minwidth: 1200px;
}
.digitization-content-right {
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.demand-customization-content-left {
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.get-product-advertisement-phone {
  p {
    display: inline-block;
  }
}
</style>
<style lang="less" scoped>
.page-wrap {
  background-color: #fff;
  .page-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    .home-canvas {
      .home-view {
        width: 100%;
        height: fit-content;
        min-width: var(--minwidth);
        position: relative;
        background-size: cover;
        z-index: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .home-view-background {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          background-position: top;
          background-size: cover;
          background-repeat: no-repeat;
          video {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center top;
          }
        }
        .home-view2 {
          height: 520px;
        }
        @media (min-width: 1440px) and (max-width: 1900px) {
          .home-view2 {
            height: 630px;
          }
        }
        @media (min-width: 1900px) {
          .home-view2 {
            height: 730px;
          }
        }
        .home-view-canvas {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 0;
        }
        .por-container {
          width: 80%;
          // max-width: 1600px;
          min-width: var(--minwidth);
          margin: 0 auto;
          position: relative;
          // display: flex;
          // align-items: center;
          .home-view-info {
            width: 39%;
            // flex: 1;
            height: 520px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            transform: translateY(-10%);
            // padding-left: 144px;
            box-sizing: border-box;
            .home-view-info-top {
              font-size: 42px;
              font-weight: bold;
              line-height: 1;
              color: #00b0dc;
              margin-bottom: 14px;
            }
            .home-view-info-title {
              font-size: 44px;
              font-weight: bold;
              line-height: 1;
              color: #000000;
              margin-bottom: 20px;
            }
            .home-view-info-content {
              font-size: 16px;
              line-height: 26px;
              color: #6d6e6f;
              margin-bottom: 30px;
            }
            .home-view-btn {
              width: 150px;
              height: 50px;
              background: #00b0dc;
              color: #fff;
              text-align: center;
              line-height: 50px;
              cursor: pointer;
              transition: border-radius 0.5s linear;
              user-select: none;
              &:hover {
                border-radius: 10px;
                transition: all 0.5s linear;
              }
            }
          }
          @media (min-width: 1440px) and (max-width: 1900px) {
            .home-view-info {
              height: 630px;
            }
          }
          @media (min-width: 1900px) {
            .home-view-info {
              height: 730px;
            }
          }
        }
      }
      .bannerbox-page {
        bottom: 80px;
        ::v-deep span {
          width: 100px;
          height: 5px;
          border-radius: initial;
          opacity: 1;
          background-color: #ccc;
          &::after {
            content: '';
            display: block;
            width: 0;
            height: 100%;
            background-color: #00b0dc;
          }
        }
        ::v-deep .swiper-pagination-bullet-active {
          &::after {
            width: 100%;
            transition: width 5s linear;
          }
        }
      }
    }
    .home-view-nav {
      width: 80%;
      min-width: 1400px;
      height: 114px;
      background: #fff;
      margin: 0 auto;
      transform: translateY(calc(-50% - 5px));
      border-radius: 10px;
      box-shadow: 0px 0px 14px #dddcdc;
      box-sizing: border-box;
      padding: 10px;
      display: flex;
      z-index: 2;
      .home-view-nav-item {
        width: 25%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .home-view-nav-item-right {
          box-sizing: border-box;
          padding-left: 20px;
          line-height: 33px;
          flex: 1;
          div {
            &:first-child {
              font-weight: 600;
            }
            &:last-child {
              font-size: 13px;
              color: rgb(139, 139, 139);
            }
          }
        }
        &::after {
          content: '';
          display: block;
          width: 2px;
          height: 50%;
          background: rgb(212, 215, 226);
          position: relative;
          top: 0;
        }
        &:last-child {
          &::after {
            content: '';
            display: none;
          }
        }
      }
    }
    .digitization-cloud-platform {
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 70px;
      .title {
        font-family: OPPOSans-M;
        font-size: 23px;
        font-weight: 600;
        color: #181818;
        text-align: center;
        margin-bottom: 69px;
      }
      .digitization-content {
        display: flex;
        justify-content: space-between;
        align-content: center;
        padding-top: 55px;
        box-sizing: border-box;
        .digitization-content-left {
          padding-top: 30px;
          flex: 1;
          .digitization-content-left-title {
            width: 310px;
            font-family: OPPOSans-M;
            font-size: 28px;
            color: #181818;
            line-height: 45px;
            margin-bottom: 35px;
          }
          .digitization-content-left-content {
            width: 100%;
            word-break: break-all;
            margin-bottom: 25px;
            display: flex;
            align-items: baseline;
            img {
              width: 16px;
              height: 16px;
              margin: 0 10px 0 0;
              transform: translateY(4px);
              vertical-align: middle;
              box-sizing: border-box;
            }
            .digitization-text {
              font-size: 16px;
              font-family: OPPOSans-R;
              color: #181818;
              line-height: 27px;
            }
          }
        }
        .digitization-content-right {
          width: 630px;
          margin-left: 70px;
          > img {
            width: 100%;
            height: auto;
          }
        }
      }
      ::v-deep .el-tabs__nav-scroll {
        width: 85%;
        margin: auto;
        display: flex;
        justify-content: center;
        .el-tabs__active-bar {
          background-color: #00b0dc;
        }
        .tag-optios-label {
          margin: 0 50px;
          text-align: center;
        }
        .el-tabs__nav {
          padding: 0 0 15px 0;
        }
      }
    }
    .demand-customization {
      width: 100%;
      background-color: #f7f9fc;
      padding-bottom: 60px;
      .customization-wrap {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        .demand-customization-title {
          font-size: 32px;
          color: #181818;
          text-align: center;
          padding: 69px 0;
          box-sizing: border-box;
        }
        .demand-customization-tag {
          display: flex;
          justify-content: center;
          .demand-customization-tag-item {
            text-align: center;
            margin: 0 25px;
            cursor: pointer;
            &:hover {
              color: #00b0dc;
              img {
                transform: scale(1.1);
              }
            }
            img {
              width: 145px;
              height: 119px;
            }
          }
          .demand-customization-tag-item-active {
            color: #00b0dc;
          }
          .demand-customization-tag-arrow {
            line-height: 119px;
          }
        }
        .demand-customization-content {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 100px;
          .demand-customization-content-left {
            width: 680px;
            height: 424px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 100%;
              height: auto;
              display: block;
            }
          }
          .demand-customization-content-right {
            flex: 1;
            margin-left: 100px;
            padding-top: 72px;
            box-sizing: border-box;
            .demand-customization-content-right-title {
              font-size: 28px;
              font-weight: 600;
              color: #181818;
              margin-bottom: 10px;
            }
            .demand-customization-panel {
              width: 100%;
              word-break: break-all;
              margin-top: 35px;
              display: flex;
              align-items: baseline;
              img {
                width: 16px;
                height: 16px;
                margin: 0 10px 0 0;
                transform: translateY(4px);
                vertical-align: middle;
                box-sizing: border-box;
              }
              div {
                font-size: 16px;
                color: #181818;
              }
            }
          }
        }
      }
    }
    .el-fade-in-linear-enter-active {
      animation: bounce-in 1.3s;
    }
    .el-fade-in-linear-leave-active {
      animation: bounce-in 0.5s reverse;
    }
    @keyframes bounce-in {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .appointment-demonstration {
      width: 100%;
      min-width: var(--minwidth);
      height: 188px;
      background-image: url('@/assets/home/appointment-demonstration.png');
      background-repeat: no-repeat;
      background-size: cover;
      text-align: center;
      color: #fff;
      padding: 22px;
      box-sizing: border-box;
      .title {
        font-size: 26px;
        margin-bottom: 20px;
        color: #fff;
      }
      .subtitle {
        font-size: 16px;
        margin-bottom: 25px;
        font-weight: 400;
      }
      .appointment-demonstration-btn {
        width: 220px;
        height: 46px;
        text-align: center;
        line-height: 46px;
        margin: auto;
        background: #00b0dc;
        border-radius: 30px;
        cursor: pointer;
        img {
          width: 18px;
          height: 22px;
          vertical-align: middle;
          margin-right: 10px;
        }
        transition: all 0.5s;
        &:hover {
          transform: scale(1.1);
          transition: all 0.5s;
        }
      }
    }
    .qyvideo {
      width: 1200px;
      min-height: 722px;
      margin: 69px auto 0;
      .bannerbox-page {
        bottom: 80px;
        display: flex;
        justify-content: center;
        ::v-deep span {
          width: 100px;
          height: 5px;
          border-radius: initial;
          opacity: 1;
          background-color: #ccc;
          &::after {
            content: '';
            display: block;
            width: 0;
            height: 100%;
            background-color: #00b0dc;
          }
        }
        ::v-deep .swiper-pagination-bullet-active {
          &::after {
            width: 100%;
            transition: width 5s linear;
          }
        }
      }
      .title {
        font-family: OPPOSans-M;
        font-size: 23px;
        font-weight: 600;
        color: #181818;
        text-align: center;
        margin-bottom: 69px;
      }
      .classic-case-centent {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
        .classic-case-List {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 25px;
          .classic-case-item {
            width: 224px;
            height: 350px;
            background-color: #fff;
            border: solid 1px #dfdfdf;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            margin: 10px 7px;
            cursor: pointer;
            .companyImg {
              width: 100%;
              height: 140px;
              .item-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center center;
                display: block;
              }
            }
            .case-item-content {
              width: 100%;
              flex: 1;
              padding: 20px 30px;
              box-sizing: border-box;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              .case-item-logo {
                width: auto;
                height: 50px;
                margin-bottom: 30px;
              }
              .case-item-text-warp {
                width: 100%;
                z-index: 1;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .case-item-title {
                  font-size: 18px;
                  line-height: 1;
                  color: #002c79;
                }
                .case-item-type {
                  font-size: 15px;
                  line-height: 1;
                  color: #363f4e;
                  margin: 19px 0 13px 0;
                }
                .case-item-describe {
                  width: 100%;
                  font-size: 15px;
                  line-height: 26px;
                  color: #737c8b;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  word-break: break-all;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 5;
                  height: 130px;
                }
              }
              .quotes-left {
                width: 52px;
                height: auto;
                z-index: 0;
                position: absolute;
                left: 0;
                bottom: 102px;
                display: block;
              }
              .quotes-right {
                width: 52px;
                height: auto;
                z-index: 0;
                position: absolute;
                right: 0;
                bottom: 45px;
                display: block;
              }
            }
          }
          .classic-case-item:hover {
            width: calc(20% - 8px);
            height: 350px;
            box-shadow: 0px 4px 8px 0px rgba(139, 139, 139, 0.18);
            margin: 6.5px 4px;
            .case-item-content {
              padding: 20.4px 30.5px;
              .case-item-logo {
                height: 51px;
                margin-bottom: 30.5px;
              }
              .case-item-text-warp {
                .case-item-title {
                  font-size: 18.3px;
                }
                .case-item-type {
                  font-size: 15.24px;
                  margin: 19.3px 0 13.2px 0;
                }
                .case-item-describe {
                  font-size: 15.3px;
                  line-height: 26.4px;
                }
              }
              .quotes-left {
                width: 53px;
              }
              .quotes-right {
                width: 53px;
              }
            }
          }
        }
      }
    }
    .enterptise-choose {
      width: 1200px;
      min-height: 722px;
      margin: 69px auto 0;
      .title {
        font-family: OPPOSans-M;
        font-size: 23px;
        font-weight: 600;
        color: #181818;
        text-align: center;
        margin-bottom: 69px;
      }
      .classic-case-centent {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .classic-case-List {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 25px;
          .classic-case-item {
            width: 386px;
            height: 445px;
            background-color: #fff;
            border: solid 1px #dfdfdf;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            margin: 10px 7px;
            cursor: pointer;
            .companyImg {
              width: 100%;
              height: 140px;
              .item-img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center center;
                display: block;
              }
            }
            .case-item-content {
              width: 100%;
              flex: 1;
              padding: 20px 30px;
              box-sizing: border-box;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              .case-item-logo {
                width: auto;
                height: 50px;
                margin-bottom: 30px;
              }
              .case-item-text-warp {
                width: 100%;
                z-index: 1;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .case-item-title {
                  font-size: 18px;
                  line-height: 1;
                  color: #363f4e;
                }
                .case-item-type {
                  font-size: 15px;
                  line-height: 1;
                  color: #363f4e;
                  margin: 19px 0 13px 0;
                }
                .case-item-describe {
                  width: 100%;
                  font-size: 15px;
                  line-height: 26px;
                  color: #737c8b;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  word-break: break-all;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                }
              }
              .quotes-left {
                width: 52px;
                height: auto;
                z-index: 0;
                position: absolute;
                left: 0;
                bottom: 102px;
                display: block;
              }
              .quotes-right {
                width: 52px;
                height: auto;
                z-index: 0;
                position: absolute;
                right: 0;
                bottom: 45px;
                display: block;
              }
            }
          }
          .classic-case-item:hover {
            width: calc(33.33% - 8px);
            height: 452px;
            box-shadow: 0px 4px 8px 0px rgba(139, 139, 139, 0.18);
            margin: 6.5px 4px;
            .case-item-content {
              padding: 20.4px 30.5px;
              .case-item-logo {
                height: 51px;
                margin-bottom: 30.5px;
              }
              .case-item-text-warp {
                .case-item-title {
                  font-size: 18.3px;
                }
                .case-item-type {
                  font-size: 15.24px;
                  margin: 19.3px 0 13.2px 0;
                }
                .case-item-describe {
                  font-size: 15.3px;
                  line-height: 26.4px;
                }
              }
              .quotes-left {
                width: 53px;
              }
              .quotes-right {
                width: 53px;
              }
            }
          }
        }
      }
      .enterprise-more-btn {
        width: 155px;
        height: 50px;
        background-color: #00b0dc;
        border-radius: 25px;
        margin: 30px auto;
        text-align: center;
        line-height: 50px;
        opacity: 1;
        color: #fff;
        cursor: pointer;
        &:hover {
          background: #00b0dc;
          opacity: 0.9;
        }
      }
      ::v-deep .el-tab-pane {
        display: flex;
      }
      ::v-deep .el-tabs__nav-scroll {
        display: flex;
        justify-content: flex-start;
        .el-tabs__active-bar {
          background-color: #00b0dc;
        }
        .el-tabs__item:hover {
          color: #00b0dc;
        }
        .is-active {
          color: #00b0dc;
        }
        .tag-optios-label {
          margin: 0 50px;
        }
        .el-tabs__nav {
          padding: 0 0 15px 0;
        }
        .el-tabs__item {
          padding: 0 30px;
        }
      }
    }
    .enterprise-partner {
      height: 89px;
      overflow: hidden;
      img {
        width: 100%;
        height: 89px;
      }
      .enterprise-partner-item-wrap {
        // border: 1px solid
        height: 82px;
        position: relative;
        top: -90px;
        left: 115px;
        display: flex;
        align-items: center;
        width: calc(100% - 116px);
        overflow: scroll;
        .enterprise-partner-item {
          flex-shrink: 0;
          min-width: 135px;
          margin: 0 5px;
          animation: scrollbarpartner infinite;
          box-sizing: border-box;
          animation-timing-function: linear;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: auto;
            height: 52px;
          }
        }
      }
    }
    .enterprise-partner-item-wrap::-webkit-scrollbar {
      width: 0px !important; /*高宽分别对应横竖滚动条的尺寸*/
      height: 0px;
    }
    .enterprise-partner-item-wrap::-webkit-scrollbar-thumb {
      border-radius: 0px !important;
      background: #acacac !important;
    }
    @keyframes scrollbarpartner {
      0% {
        transform: translateX(0);
        // transform: translateX(var(--parnertwrapscrollWidth));
      }
      100% {
        // transform: translateX(var(--parnertwrapscrollWidth));
        // transform: translateX(0)
        transform: translateX(calc(var(--parnertwrapscrollhiddenWidth) * -1));
      }
    }
    .enterprise-advertisement {
      width: 100%;
      min-width: var(--minwidth);
      height: 450px;
      margin-top: 60px;
      background-image: url('@/assets/home/enterprise-advertisement.png');
      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      padding-top: 43px;
      // background: #2979ff;
      .enterprise-advertisement1 {
        width: 612px;
        height: 39px;
        display: block;
        margin: 0px auto 49px;
        box-sizing: border-box;
      }

      .get-product-advertisement-btn {
        margin: 24px auto 10px;
        width: 242px;
        height: 46px;
        background-color: #ffffff;
        border-radius: 23px;
        font-size: 18px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 1px;
        color: #00b0dc;
        text-align: center;
        line-height: 46px;
        cursor: pointer;
        transition: border-radius 0.5s linear;
        user-select: none;
        &:hover {
          border-radius: 10px;
          transition: border-radius 0.5s linear;
          // background: #2a7aff;
          // color: #fff;
        }
      }
      .get-product-advertisement-phone {
        width: 305px;
        margin: auto;
        color: #fff;
        img {
          width: 14px;
          height: 14px;
          margin: 0 8px 0 0;
        }
      }
    }
  }
  .enterprise-advertisement-num {
    display: flex;
    justify-content: center;
    .enterprise-advertisement-num-item {
      width: 409px;
      // border: 1px solid;
      text-align: center;
      .enterprise-advertisement-num-item-top,
      .enterprise-advertisement-num-item-foot {
        div:first-child {
          font-size: 36px;
          font-weight: normal;
          font-style: italic;
          font-stretch: normal;
          line-height: 32px;
          letter-spacing: 0px;
          color: #f6f9fc;
          font-weight: 600;
          margin-bottom: 19px;
        }
        div:last-child {
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 32px;
          letter-spacing: 0px;
          color: #f6f9fc;
          opacity: 0.9;
        }
      }
      .enterprise-advertisement-num-item-top {
        margin-bottom: 46px;
      }
    }
  }
  .enterprise-foot-info {
    width: 100%;
    min-width: var(--minwidth);
    height: 502px;
    background: #f7f7f7;
    padding-top: 59px;
    display: flex;
    justify-content: center;
    .enterprise-foot-info-log {
      img {
        width: 104px;
        height: 23px;
      }
    }
    .enterprise-foot-project-title {
      margin: 0 50px;
      font-size: 14px;
      font-weight: 600;
      color: #181818;
    }
    .enterprise-foot-project {
      height: 346px;
      writing-mode: vertical-lr;
      margin: 22px 50px 0;
      box-sizing: border-box;
      .enterprise-foot-project-item {
        margin-right: 59px;
        margin-bottom: 19px;
        display: inline-block;
        font-size: 14px;
        writing-mode: lr-tb;
        vertical-align: text-bottom;
      }
      .enterprise-foot-contact-item {
        display: inline-block;
        margin: 22px 0 0px;
        width: 337px;
        writing-mode: lr-tb;
        vertical-align: text-bottom;
        .qrcode-wrap {
          display: flex;
          div {
            margin: 0 20px 0 0;
          }
        }
        .qrcode-app {
          padding: 5px;
          background: #fff;
          width: fit-content;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
